const initialState = () => {
    return {
        notifications: []
    };
};

const state = () => initialState();

const getters = {
    getNotifications: state => state.notifications,
    takeLastNotification: state => state.notifications.pop()
};

const mutations = {
    setNotifications: (state, notifications) => {
        state.notifications = notifications;
    },
    addNotification: (state, notification) => {
        state.notifications.push(notification);
    },
    clearState: state => {
        state.notification = [];
    }
};

const actions = {};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
